import React from "react";
import ReactDOM from "react-dom";
import { withRouter } from "react-router-dom";
import {ReactComponent as CheckMark} from "../../../../assets/images/icons/icon-check.svg";
import {ReactComponent as SmallCheckIcon} from '../../../../assets/images/landing/check-icon.svg'

class SubServiceItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showFeaturesModal: false,
      showHoverTooltip: false,
      tooltipPos: null
    }

    this.hoverTimeout = null
    this.hideTimeout = null
    this.titleRef = React.createRef()
  }

  isDesktop() {
    return window.matchMedia('(min-width: 751px)').matches
  }

  handleTitleMouseEnter = () => {
    const features = this.props.subservice.content?.features || []
    if (this.props.homepage && features.length > 0 && this.isDesktop()) {
      this.hoverTimeout = setTimeout(() => {
        if (this.titleRef.current) {
          const rect = this.titleRef.current.getBoundingClientRect()
          this.setState({showHoverTooltip: true, tooltipPos: rect})
        }
      }, 300)
    }
  }

  handleTitleMouseLeave = () => {
    if (this.hoverTimeout) clearTimeout(this.hoverTimeout)
    this.hideTimeout = setTimeout(() => this.setState({showHoverTooltip: false}), 100)
  }

  handleTooltipMouseEnter = () => {
    if (this.hideTimeout) clearTimeout(this.hideTimeout)
  }

  handleTooltipMouseLeave = () => {
    this.setState({showHoverTooltip: false})
  }

  handleTitleClick = (e) => {
    const features = this.props.subservice.content?.features || []
    if (this.props.homepage && features.length > 0) {
      if (this.props.selected) e.stopPropagation()
      // Mobile modal disabled — re-enable by uncommenting the block below
      // if (!this.isDesktop()) {
      //   this.setState({showFeaturesModal: true})
      // }
    }
  }

  render() {
    let subservice = this.props.subservice;
    const features = subservice.content?.features || []

    let sub_service_price = this.props.project?.invoice_sub_services[subservice.id] ? this.props.project?.invoice_sub_services[subservice.id].price : this.props.location_pricing && this.props.location_pricing[subservice.id] ? this.props.location_pricing[subservice.id].price : subservice.price
    if (!this.props.project?.invoice_sub_services[subservice.id] && this.props.project?.invoices && Object.values(this.props.project.invoices)[0].discounted > 0) {
      sub_service_price = Math.ceil(sub_service_price * (1 - Object.values(this.props.project.invoices)[0].discounted / 100))
    }
    const discountCode = this.props.project?.discount_code
    if (!this.props.project?.invoice_sub_services[subservice.id] && discountCode && sub_service_price > 0) {
      const codeDiscount = discountCode.percentage
        ? sub_service_price * discountCode.amount / 100.0
        : Math.min(discountCode.amount, sub_service_price)
      sub_service_price = Math.round(sub_service_price - codeDiscount)
    }


    const isPlusAddon = subservice.title?.startsWith('+')
    const isDisabled = isPlusAddon && !this.props.hasBaseSelected

    return (
      <div onClick={() => !isDisabled && this.props.toggleSelected(subservice)}
           className={`subserviceItem ${this.props.selected ? 'subserviceItemSelected' : ''} ${isDisabled ? 'subserviceItemDisabled' : ''}`}
           key={subservice.id}>
        {!this.props.new_order_process && !this.props.new_update_process && <div className="subserviceItemPrice">${sub_service_price}</div>}
        <div className={`subserviceItemTitle ${this.props.homepage && features.length > 0 ? 'subserviceItemTitleClickable' : ''}`}
             id={subservice.description ? "subserviceItemTitleMargin" : ""}
             ref={this.titleRef}
             onMouseEnter={this.handleTitleMouseEnter}
             onMouseLeave={this.handleTitleMouseLeave}>
          {subservice.title}
          {this.state.showHoverTooltip && this.state.tooltipPos && ReactDOM.createPortal(
            <div className="serviceFeaturesTooltip" style={{position: 'fixed', top: this.state.tooltipPos.bottom + 8, left: this.state.tooltipPos.left + this.state.tooltipPos.width / 2, transform: 'translateX(-50%)', zIndex: 100001}} onClick={(e) => e.stopPropagation()} onMouseEnter={this.handleTooltipMouseEnter} onMouseLeave={this.handleTooltipMouseLeave}>
              {features.map((item, i) => (
                <div className="serviceFeaturesModalItem" key={`feature-${i}`}>
                  <SmallCheckIcon />
                  <div>{item}</div>
                </div>
              ))}
            </div>,
            document.body
          )}
        </div>
        {subservice.description && <div className="subserviceItemDescriptionAndList">
          <div className="subserviceItemDescription">{subservice.description}</div>
        </div>}

        {this.props.selected && <div className="checkIcon2">
          <CheckMark/>
        </div>}

        {this.state.showFeaturesModal && <div className="modal-background" onClick={(e) => { e.stopPropagation(); this.setState({showFeaturesModal: false}) }}>
          <div className="serviceFeaturesModal" onClick={(e) => e.stopPropagation()}>
            <div className="serviceFeaturesModalHeading">{subservice.title}</div>
            {subservice.description && <div className="serviceFeaturesModalDescription">{subservice.description}</div>}
            <div className="serviceFeaturesModalList">
              {features.map((item, i) => (
                <div className="serviceFeaturesModalItem" key={`feature-${i}`}>
                  <SmallCheckIcon />
                  <div>{item}</div>
                </div>
              ))}
            </div>
            <div className="text-center mt-3">
              <button className="settingsButton companyButton closeButton m-0" onClick={(e) => { e.stopPropagation(); this.setState({showFeaturesModal: false}) }}>Close</button>
            </div>
          </div>
        </div>}
      </div>
    )
  }
}

export default withRouter(SubServiceItem);